import { defineStore, acceptHMRUpdate } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 导入本地化语言
import { useUserStore } from '@/store/index'
import { getTts } from '@/service/index'
export const useAlertStore = defineStore(
  'alert',
  () => {
    dayjs.locale('zh-cn')
    const messages = reactive<Array<Message>>([])
    const audio = ref<HTMLAudioElement>()
    //播放总次数
    let playCount = ref(2)
    let nextId = 0
    interface Message {
      id: number
      content: string
      closable: boolean
      type: string
      date: string
    }
    function addMessage(
      data: any,
      closable: boolean = true,
      type: string = 'info',
      autoClose: boolean = false,
    ) {
      const id = nextId++
      console.log(data)

      messages.unshift({
        id: id,
        content: data.msg,
        closable,
        type,
        date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })
      // #ifdef APP-PLUS
      const player = plus.audio.createPlayer('/static/images/new.mp3')
      player.play()
      // #endif
      // #ifdef H5
      uni.$tools.audioPlay(audio.value, '/static/images/new.mp3')
      // #endif
      audioPlay(data)


      if (autoClose) {
        setTimeout(() => {
          removeMessage(id)
        }, 8000)
      }
    }

    function removeMessage(id: number) {
      const index = messages.findIndex((msg) => msg.id === id)
      if (index !== -1) {
        messages.splice(index, 1)
      }
    }
    function clearAll() {
      messages.splice(0)
    }
    async function audioPlay(res: any) {
      if (!res.msg) return
      try {
        let { data: audioData } = await getTts({
          text: res.voice,
        })
        if (audioData.url) {
          // #ifdef APP-PLUS
          const player = plus.audio.createPlayer(
            import.meta.env.VITE_IMG_BASEURL + audioData.url,
          )
          player.play()
          // #endif
          // #ifdef H5
          uni.$tools.audioPlay(audio.value, import.meta.env.VITE_IMG_BASEURL + audioData.url)
          // #endif
        }
        // var dtask = plus.downloader.createDownload(import.meta.env.VITE_IMG_BASEURL + "/shop/tts/voice?text=" + res.voice, {
        //   method: 'GET',
        // }, function (d, status) {
        //   // 下载完成
        //   if (status == 200) {
        //     console.log("Download success: " + d.filename);
        //     // 创建播放器并播放本地文件
        //     const player = plus.audio.createPlayer(d.filename);
        //     player.play(() => {
        //       // 播放完成后删除文件
        //       plus.io.resolveLocalFileSystemURL(d.filename, function (entry) {
        //         entry.remove(function () {
        //           console.log("File deleted successfully: " + d.filename);
        //         }, function (error) {
        //           console.log("Failed to delete file: " + error.message);
        //         });
        //       });
        //     })
        //   } else {
        //     console.log("Download failed: " + status);
        //   }
        // });

        // dtask.setRequestHeader('Content-Type', 'application/json')
        // dtask.setRequestHeader('Authorization', 'Bearer ' + token)
        // dtask.start();
      } catch (error) {
        console.log('tts err', error)
      }
    }

    return {
      addMessage,
      removeMessage,
      clearAll,
      audioPlay,
      messages,
      audio,
    }
  },
  {
    persist: true,
  },
)
// 确保传递正确的 store 声明
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAlertStore, import.meta.hot))
}
